module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO21QueSonIngresosVariables (52).ce0aeab.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO21QueSonIngresosVariables (52).mp4
// module id = 747
// module chunks = 1